import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Category} from 'shared/models/target-groups/category';
import {CategoriesRepository} from '../repositories/categories.repository';

@Injectable()
export class CategoriesService {

  constructor(private categoriesRepository: CategoriesRepository) { }

  public getAllCategories(): Observable<Array<Category>> {
    return this.categoriesRepository.getAllCategories();
  }

  public getCategory(id: String): Observable<Category> {
    return this.categoriesRepository.getCategory(id);
  }

  public createCategory(newCategoryName: String): Observable<Category> {
    const newCategory: Category = {
      name: newCategoryName,
    };
    return this.categoriesRepository.createCategory(newCategory);
  }

  public updateCategory(category: Category): Observable<Category> {
    return this.categoriesRepository.updateCategory(category);
  }

  public deleteCategory(category: Category): Observable<boolean> {
    return this.categoriesRepository.deleteCategory(category);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/categories/services/categories.service.ts